import React from "react"
import { PageContainer } from "../../shared/Refactor/Containers"
import Investors from "../Investors"
import Advisors from "./Advisors"


const Team = () => {
  return <PageContainer>
    <Investors />
    <Advisors />
  </PageContainer>
}

export default Team